import * as React from "react";
type Props = {
  className?: string,
};
function SvgApple({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Apple"
      className={className}
    >
      <path
        d="M15.1884 4.23843C15.8854 3.36666 16.3584 2.19614 16.2336 1C15.2134 1.05073 13.9683 1.67311 13.2475 2.54556C12.6003 3.29268 12.0274 4.51221 12.1768 5.65821C13.3221 5.75755 14.4663 5.08573 15.1884 4.23843Z"
        fill="black"
      />
      <path
        d="M16.2207 5.6746C14.5574 5.57553 13.1432 6.61859 12.3489 6.61859C11.5542 6.61859 10.3379 5.72453 9.02229 5.74863C7.31002 5.77378 5.72122 6.74191 4.85231 8.2817C3.06511 11.362 4.38067 15.9313 6.11863 18.44C6.96262 19.6812 7.97977 21.0478 9.32002 20.9987C10.5863 20.949 11.0827 20.1788 12.6219 20.1788C14.1601 20.1788 14.6072 20.9987 15.9476 20.9739C17.3377 20.949 18.2068 19.7321 19.0508 18.4897C20.019 17.0749 20.4153 15.7087 20.4403 15.6337C20.4153 15.6088 17.7598 14.5901 17.7351 11.5354C17.7101 8.97759 19.8201 7.76097 19.9194 7.68552C18.7278 5.92324 16.8661 5.72453 16.2207 5.6746Z"
        fill="black"
      />
    </svg>
  );
}
export default SvgApple;
